import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/en-gb';

moment.lang('en-gb', lang);



// WEBPACK FOOTER //
// ./src/web/js/app/datetime.en-gb.js